import { render, staticRenderFns } from "./InformationToCustomerSection.vue?vue&type=template&id=06dee92a&"
import script from "./InformationToCustomerSection.vue?vue&type=script&lang=js&"
export * from "./InformationToCustomerSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports